import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Input } from "@/components/elements/Input";
import { Grid, Stack } from "@mui/material";
import { FC } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { Select } from "@/components/elements/Select";
import { JobFormTitle } from "@/features/job/components/job-form/JobFormTitle";
import { TJobForm } from "@/features/job/types/JobForm";
import { useEnum } from "@/api/services/global/enum";
import { RadioGroup } from "@/components/elements/RadioGroup";
import { YES_NO_PENDING_STATUS } from "@/types/enum";

type TJobEmploymentConditionProps = {
  isDraft?: boolean;
};

export const JobEmploymentCondition: FC<TJobEmploymentConditionProps> = ({ isDraft }) => {
  const methods = useFormContext<TJobForm>();
  const { control, setValue: _setValue } = methods;
  const { data: employmentTypeOptions } = useEnum("EEmploymentType");
  const { data: salaryTypeOptions } = useEnum("ESalaryType");
  const { data: yesNoPendingStatusOptions } = useEnum("EYesNoPendingStatus");

  const bonusWatchField = useWatch({
    control,
    name: "bonus",
  });

  const salaryRaiseWatchField = useWatch({
    control,
    name: "salaryRaise",
  });

  return (
    <Stack gap={2}>
      <InnerBox title={<JobFormTitle text="雇用条件" /> } showDivider={false}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormField control={control} name="businessContent">
              <Input placeholder="入力してください" />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="employmentType" required={!isDraft}>
              <Select placeholder="選択してください" options={employmentTypeOptions} />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="salaryType">
              <Select placeholder="選択してください" options={salaryTypeOptions} />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="baseSalary" required={!isDraft}>
              <Input placeholder="入力してください" endAdornment="円" clearable={false} />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="totalAmount">
              <Input placeholder="入力してください" endAdornment="円" clearable={false} />
            </FormField>
          </Grid>
          <Grid item xs={12}>
            <FormField control={control} name="totalAmountBreakdown">
              <Input placeholder="入力してください" />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="netSalaryEstimate">
              <Input placeholder="入力してください" endAdornment="円" clearable={false} />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="salaryDeductions">
              <Input placeholder="入力してください" />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="hourlyWage">
              <Input placeholder="入力してください" endAdornment="円" clearable={false} />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="otherAllowanceAmount">
              <Input placeholder="入力してください" endAdornment="円" clearable={false} />
            </FormField>
          </Grid>
          <Grid item xs={12}>
            <FormField control={control} name="otherAllowanceDescription">
              <Input placeholder="入力してください" />
            </FormField>
          </Grid>
          <Grid item xs={12}>
            <FormField control={control} name="overtimeDescription">
              <Input placeholder="入力してください" />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="bonus" required={!isDraft}>
              <RadioGroup
                direction="row"
                options={yesNoPendingStatusOptions}
                onChange={(value) => {
                  if (value !== YES_NO_PENDING_STATUS.YES) {
                    methods.setValue("bonusInfo", "");
                  }
                }}
              />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="bonusInfo">
              <Input placeholder="入力してください" disabled={bonusWatchField !== YES_NO_PENDING_STATUS.YES} />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="salaryRaise" required={!isDraft}>
              <RadioGroup
                direction="row"
                options={yesNoPendingStatusOptions}
                onChange={(value) => {
                  if (value !== YES_NO_PENDING_STATUS.YES) {
                    methods.setValue("salaryRaiseTime", "");
                  }
                }}
              />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="salaryRaiseTime">
              <Input placeholder="入力してください" disabled={salaryRaiseWatchField !== YES_NO_PENDING_STATUS.YES} />
            </FormField>
          </Grid>
        </Grid>
      </InnerBox>
    </Stack>
  );
};
